import React from 'react';
import Debug from 'src/App/components/Debug/Debug';
import { TscAuthProvider } from 'src/shared/hooks/useTscAuth';

export const DebugScene = () => (
  <TscAuthProvider>
    <Debug />
  </TscAuthProvider>
);
